import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { AssetsService } from '@app/shared/services/assets.service';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { IconComponent } from '@app/shared/components/icon/icon.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-discontinued-reward-modal',
  templateUrl: './discontinued-reward.component.html',
  styleUrls: ['./discontinued-reward.component.scss'],
  standalone: true,
  imports: [IconComponent, ButtonComponent, SharedModule],
})
export class DiscontinuedRewardModalComponent implements OnInit {
  discontinuedRewardModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private assetsService = inject(AssetsService);
  private eventManager = inject(EventManager);
  private logger = inject(LoggerService);

  gameIcon: object;

  ngOnInit(): void {
    this.assetsService.gamesVersion$.subscribe({
      next: (versions) => {
        const url = this.assetsService.getGameIconUrlLegacy(
          this.discontinuedRewardModalData.properties.gameId,
          versions
        );
        this.gameIcon = { 'background-image': `url('${url}')` };
      },
      error: (error) => this.logger.error(error),
    });
  }

  redeem() {
    this.eventManager.closeModal(
      new Modal(this.discontinuedRewardModalData.id, ModalType.Persisted, this.discontinuedRewardModalData)
    );
  }
}
